<div *ngIf="conversation" class="conversation-container">
    <h3> Activities </h3>
    <div class="activity-container">
        <particle-activity
            class="mentioned-activity"
            [conversation]="conversation"
            [allContacts]="allContacts">
        </particle-activity>
    </div>
</div>